import { isEmpty } from '../../../common/utils/utils';

interface StylesObject {
  playlistWrapperStyle: { [key: string]: any };
  leftArrowStyle: { [key: string]: any };
  rightArrowStyle: { [key: string]: any };
}

type PlaylistWrapperStyleObject = {
  endState: { [key: string]: any };
  splitView: { [key: string]: any };
} & any;

const getPlaylistWrapperStyle = (splitViewRatio: number): PlaylistWrapperStyleObject => ({
  width: '173px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: '4',
  endState: {
    width: '247px',
  },
  splitView: {
    left: `${splitViewRatio / 2}%`,
    transform: 'translate(-50%, 0)',
    position: 'absolute',
  },
});

const leftArrow = {
  position: 'absolute',
  cursor: 'pointer',
  pointerEvents: 'auto',
  left: '0px',
};

const rightArrow = {
  position: 'absolute',
  cursor: 'pointer',
  pointerEvents: 'auto',
  right: '0px',
};

export const getMiddleScreenPlaylistViewStyleObject = (isEndState: boolean, splitViewRatio: number): StylesObject => {
  const playlistWrapper = getPlaylistWrapperStyle(splitViewRatio);
  const splitView = !isEmpty(splitViewRatio);

  return ({
    playlistWrapperStyle: [
      playlistWrapper,
      splitView && !isEndState && playlistWrapper.splitView,
      isEndState && playlistWrapper.endState,
    ],
    leftArrowStyle: {
      ...leftArrow,
    },
    rightArrowStyle: {
      ...rightArrow,
    },
  });
};
